import saman from "../assets/imgs/saman.png";
import mirasLogo from "../assets/imgs/miras.png";
import air from "../assets/imgs/air.png";
import passenger from "../assets/imgs/passenger.png";
import lohoaira from "../assets/imgs/lohoaira.png";
import virtual from "../assets/imgs/virtual.png";
import daneshBonyan from "../assets/imgs/daneshBonyan.png";

const domain = window.location.hostname;
const isIR = domain.endsWith(".ir");
const isCOM = domain.endsWith(".com");
console.log(domain);

export const PERMISSIONS = [
    {
        name: "enamad",
        href: isIR
            ? "https://trustseal.enamad.ir/?id=322394&Code=tharoDr5MrfjIyvDSPJD"
            : "https://trustseal.enamad.ir/?id=306873&amp;Code=4tnYVbdk9PT4A5lq2rlo",
        src: isIR
            ? "https://Trustseal.eNamad.ir/logo.aspx?id=322394&Code=tharoDr5MrfjIyvDSPJD"
            : "https://Trustseal.eNamad.ir/logo.aspx?id=306873&amp;Code=4tnYVbdk9PT4A5lq2rlo",
    },
    {
        name: "samandehi",
        href: "https://logo.samandehi.ir/Verify.aspx?id=343268&p=xlaoaodsxlaouiwkgvkamcsi",
        src: saman,
    },
    {
        name: "miras",
        href: "/fa/miras",
        src: mirasLogo,
    },
    {
        name: "sazman havaii",
        href: "https://www.caa.gov.ir",
        src: air,
    },
    {
        name: "passenger",
        href: "https://farasa.cao.ir/sysworkflow/fa/modern/3810212626028ab03488017019616799/6464336316028ab04e3c618028352200.php",
        src: passenger,
    },
    {
        name: "airline",
        href: "http://aira.ir/",
        src: lohoaira,
    },
    {
        name: "vitual business",
        href: "https://qr.mojavez.ir/trace/1709522",
        src: virtual,
    },
    {
        name: "daneshBonyan",
        href: "https://api.atripa.com/media/daneshbonyan_cert.pdf",
        src: daneshBonyan,
    },
];
